
import manualButton from '../manual-button';
import doubleDate from './double-date';
import dateFormat from 'vux/src/tools/date/format.js'
import Datetime from 'vux/src/components/datetime/index.vue'

export default {
name: "purchase-apply-p",
components: {
manualButton,
doubleDate,
Datetime
},
data() {
return {
baseDo: {
supplyTypeName: '',
time: '',
name: "",
depName: "",
plantName: ""
},
purTypeList: [],
typeShowValueList: [],
orderStateList: [
{name:'全部',code:'',selected:true},
{name:'待确认',code:'1'},
{name:'已确认',code:'2'},
{name:'已作废',code:'6'},
{name:'已退回',code:'7'}
],
supOrderStateList:[
{name:'全部',code:'',selected:true},
{name:'待确认',code:'1'},
{name:'已确认',code:'2'}
],
sourceSystemList:[],
checkedDtoList:[],
purorgList:[],
delList: [
{name:'全部',code:''},
{name:'是',code:'1'},
{name:'否',code:'0'}
],
startTime:'',
endTime:'',
dateTitle:'',
isManualShow:true,
}
},
methods: {
showPlugin () {
const _this = this;
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD HH',
value: '2017-05-20 18',
onConfirm (val) {
_this.baseDo.time = val;
console.log('plugin confirm', val,_this)
},
onShow () {
console.log('plugin show')
},
onHide () {
console.log('plugin hide')
}
})
},
concactInputChange(e,filed){
if(e){
this.checkerChange(e,filed.filed,filed.name,filed.option)
}
},
inputReset(name){
this.checkedDtoList=this.checkedDtoList.filter(val=>val.ch!=name)
},
reload(){
this.checkedDtoList=[];
this.startTime='';
this.endTime='';
this.$refs.manulaDate.resetTime();
this.baseDo = {
supplyTypeName: '',
time: '',
name: "",
depName: "",
plantName: ""
}
this.show=false;
this.$nextTick(()=>{
this.show=true;
})
},
closeReset(){
this.isManualShow=true;
this.$refs.manulaDate.show=false;
},
checkerChange(value,name,chinese,option="IN"){
if(value){
this.checkedDtoList=this.checkedDtoList.filter(val=>val.name!=name)
this.checkedDtoList.push({name,code:value,ch:chinese,option:option});
}else{
this.inputReset(name)
};
},
chooseDate(e){
this.isManualShow=false;
this.$refs.manulaDate.dateTitle=e;
this.$refs.manulaDate.show=true;
},
dateChoose(e){
if(e.startTime){
this.startTime=dateFormat( new Date(e.startTime).getTime(),"YYYY-MM-DD", 'zh')
this.endTime=dateFormat( new Date(e.endTime).getTime(),"YYYY-MM-DD", 'zh')
this.checkerChange([e.startTime,e.endTime],'demandDate','date','BTD');
this.baseDo.demandDate = this.startTime + ' - ' + this.endTime
}else {
this.startTime='';
this.endTime='';
this.checkedDtoList=this.checkedDtoList.filter(val=>val.ch!='date')
}
this.isManualShow=true;
},

getSourceSystemList(){
this.$loadingShow();
this.$get('api/dict-tables/search-with-list', {
dictCode: "sourceSystem"
}).then((data) => {
this.$loadingHide()
this.sourceSystemList = data.dictItems.map(item => {
item.name = item.value;
return item;
});
this.sourceSystemList.unshift({name:'全部',code:''});
}).catch(()=>{
this.$loadingHide()
})
},

getPurorgList() {
this.$loadingShow();
this.$get('api/purorg').then((data) => {
data.forEach(val=>{
val.name=val.purorgName;
val.code=val.purorgCode
})
this.purorgList = data.filter(item =>{
return item.enabled;
});;
this.purorgList.unshift({code: '', name: '全部'})
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
getTypeValueList(){
this.$get('api/pur-requisition-type/all').then((res) => {
if(res){
this.typeShowValueList = [{name:'全部',code: ''}];
res.forEach((item) => {
let obj = {
name:item.value,
code:item.code
};
this.typeShowValueList.push(obj);
});
}
});
this.$get('api/dict-tables/search-with-list?dictCode=priceType').then((res) => {
if(res && res.dictItems){
this.purTypeList = [{name:'全部',code: ''}];
res.dictItems.forEach((item) => {
let obj = {
name:item.value,
code:item.code
};
this.purTypeList.push(obj);
});
}
})
}
},

created() {
this.getTypeValueList();
this.getPurorgList();
this.getSourceSystemList();
}


}



// WEBPACK FOOTER //
// ./src/components/manual-search/purchase-apply-p.vue